import { jsx as _jsx } from "react/jsx-runtime";
import { StyledModalBackgroundComponent } from "./modal-background-component.scss";
const ModalBackgroundComponent = (props)=>{
    const { onClick } = props;
    return /*#__PURE__*/ _jsx(StyledModalBackgroundComponent, {
        className: "modal-background",
        onClick: onClick
    });
};
export default ModalBackgroundComponent;
